import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logout } from "../Redux/Authentication";
import IconSite from "../../assets/icons/icon-site.svg";
import IconUser from "../../assets/icons/icon-user.svg";
import IconLocker from "../../assets/icons/icon-lockers.svg";
import IconLockers from "../../assets/icons/icon-pickup.svg";
import IconLogout from "../../assets/icons/logout.svg";
import IconDashboard from "../../assets/icons/icon-dashboard.svg";
import Envelope from "../../assets/icons/envelope.svg";
import Clock from "../../assets/icons/clock.svg";
import IconContent from "../../assets/icons/icon-content.svg";
import IconDepartment from "../../assets/icons/icon-user.svg";
import { NavLink } from "react-router-dom";
import "./partials.css";
import AXIOS from "../../config/axios";
const Sidebar = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.user);
  const [showDepartments, setShowDepartments] = useState(false);
  const handleUserLogout = async (e) => {
    console.log("logout");
    const id = localStorage.getItem("token");
    const logouts = await localStorage.removeItem("token");
    dispatch(logout());
    AXIOS.get("/auth/user/update/chatStatusOffline")
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
    navigate("/");
  };
  useEffect(() => {
    const role = isAuthenticated?.role;
    if (role === "superAdmin") {
      setShowDepartments(true);
      return;
    }
    if (role !== "admin" || !isAuthenticated?.site_id) {
      setShowDepartments(false);
      return;
    }
    const base = process.env.REACT_APP_APP_BACK_URL;
    fetch(`${base}/api/sites/getSite/${isAuthenticated.site_id}`)
      .then((res) => res.json())
      .then((json) => {
        setShowDepartments(json?.site?.departments_enabled === "yes");
      })
      .catch(() => setShowDepartments(false));
  }, [isAuthenticated?.role, isAuthenticated?.site_id]);
  return (
    <div>
      <section className="sidebar_wrap">
        <div className="logo-wrap text-center">
          <Link to="/dashboard">
            <img
              src="/invid_logo.png?v=2"
              alt="logo"
              style={{ width: "180px", maxWidth: "100%", height: "auto" }}
            />
          </Link>
        </div>
        <ul>
          <li>
            <NavLink to="/dashboard">
              <img src={IconDashboard} alt="icon" />
              <span>Dashboard</span>
            </NavLink>
          </li>
          {(isAuthenticated?.role === "superAdmin" ||
            isAuthenticated?.role === "admin" ||
            isAuthenticated?.role === "staff") && (
            <>
              {(isAuthenticated?.role === "superAdmin" ||
                isAuthenticated?.role === "admin") && (
                <>
                  <li>
                    <NavLink to="/user/list">
                      <img src={IconUser} alt="icon" />
                      <span>Users</span>
                    </NavLink>
                  </li>

                  {isAuthenticated?.role === "superAdmin" && (
                    <li>
                      <NavLink to="/site/list">
                        <img src={IconSite} alt="icon" />
                        <span>Sites</span>
                      </NavLink>
                    </li>
                  )}

                  <li>
                    <NavLink to="/locker/list">
                      <img src={IconLocker} alt="icon" />
                      <span>Lockers</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/communications/list">
                      <img src={Envelope} alt="icon" />
                      <span>Communication</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/time-out/list">
                      <img src={Clock} alt="icon" />
                      <span>Time Outs</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manual/list">
                      <img src={IconContent} alt="icon" />
                      <span>Manual</span>
                    </NavLink>
                  </li>
                  {showDepartments && (
                    <li>
                      <NavLink to="/department/list">
                        <img src={IconDepartment} alt="icon" />
                        <span>Departments</span>
                      </NavLink>
                    </li>
                  )}
                </>
              )}

              {(isAuthenticated?.role === "admin" ||
                isAuthenticated?.role === "staff") && (
                <li>
                  <NavLink to="/pickup/add">
                    <img src={IconSite} alt="icon" />
                    <span>Book A Pickup</span>
                  </NavLink>
                </li>
              )}

              <li>
                <NavLink to="/pickup/list">
                  <img src={IconLockers} alt="icon" />
                  <span>Your Pickup List</span>
                </NavLink>
              </li>
            </>
          )}

          {isAuthenticated?.role === "user" && (
            <>
              <li>
                <NavLink to="/pickup/order">
                  <img src={IconLocker} alt="icon" />
                  <span>Pickup Order</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/pickup/list">
                  <img src={IconLockers} alt="icon" />
                  <span>Your Pickup List</span>
                </NavLink>
              </li>
            </>
          )}

          <li>
            <Link onClick={handleUserLogout}>
              <img src={IconLogout} alt="icon" />
              <span>Logout</span>
            </Link>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default Sidebar;
